import {useMemo} from 'react'
import useContentAsset from './use-content-asset.js'

const useLocaleSpecificUrl = (path) => {
    const {isLoading, data: localeSpecificUrl} = useContentAsset('locale-specific-url-headless')
    const url = useMemo(() => {
        if (!localeSpecificUrl || !localeSpecificUrl.body || isLoading) {
            return null
        }

        try {
            const parser = new DOMParser()
            const doc = parser.parseFromString(localeSpecificUrl.body, 'text/html')
            const link = doc.querySelector(`a#${path}`)
            return link?.getAttribute('href') || null
        } catch (error) {
            console.log('Error parsing HTML:', error)
            return null
        }
    }, [localeSpecificUrl, path, isLoading])

    return url
}

export default useLocaleSpecificUrl
